import { Box } from '@mui/material';
import AppBar from 'AppBar';
import AppThemeProvider from 'AppThemeProvider';
import AuthEffects from 'AuthEffects';
import { getLocalBoards } from 'localStorage';
import { POPULAR_BOARDS } from 'PopularBoards';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import Routing from 'Routing';
import SignInModal from 'SignInModal';

import { boardInstanceAtomFamily, localBoardIDsAtom } from 'state/recoilState';

function App() {
  return (
    <RecoilRoot
      initializeState={({ set }) => {
        for (const board of POPULAR_BOARDS) {
          set(boardInstanceAtomFamily(board.id), board);
        }

        const localBoards = getLocalBoards();
        const localBoardIDs = localBoards.map(({ id }) => id);

        set(localBoardIDsAtom, localBoardIDs);

        for (const board of localBoards) {
          set(boardInstanceAtomFamily(board.id), board);
        }
      }}
    >
      <AppThemeProvider>
        <BrowserRouter>
          <AuthEffects />
          <SignInModal />

          <Box>
            <AppBar />
            <Box sx={{ display: 'flex', mt: 10 }}>
              <Routing />
            </Box>
          </Box>
        </BrowserRouter>
      </AppThemeProvider>
    </RecoilRoot>
  );
}

export default App;
